import { useEffect } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import { usePrevious } from "./usePrevious";

/**
 * Forces a full page reload when the current account changes, since
 * template visibility is scoped server-side to the session cookie.
 */
export const useReloadOnAccountChange = () => {
  const rawAccountId = useCurrentAccountId();
  // Anonymous visitors get NaN, not undefined; NaN !== NaN would misfire on every render.
  const currentAccountId =
    typeof rawAccountId === "number" && Number.isFinite(rawAccountId)
      ? rawAccountId
      : undefined;
  const previousAccountId = usePrevious(currentAccountId);

  useEffect(() => {
    if (
      previousAccountId !== undefined &&
      currentAccountId !== undefined &&
      currentAccountId !== previousAccountId
    ) {
      window.location.reload();
    }
  }, [currentAccountId, previousAccountId]);
};
